import { render, staticRenderFns } from "./BetItem.vue?vue&type=template&id=6c6dbd5e&scoped=true&"
import script from "./BetItem.vue?vue&type=script&lang=js&"
export * from "./BetItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6dbd5e",
  null
  
)

export default component.exports